var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTarget03 = function SvgTarget03(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#9aea938b-74c8-429a-b4cf-6e7b5595178aa)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#60646C",
    fillRule: "evenodd",
    d: "M8 .667c.369 0 .667.298.667.666v.704a6 6 0 0 1 5.297 5.296h.703a.667.667 0 1 1 0 1.334h-.703a6 6 0 0 1-5.297 5.296v.704a.667.667 0 1 1-1.333 0v-.704a6 6 0 0 1-5.297-5.296h-.703a.667.667 0 0 1 0-1.334h.703a6 6 0 0 1 5.297-5.296v-.704c0-.368.298-.666.666-.666M7.334 3.38A4.67 4.67 0 0 0 3.38 7.333H4a.667.667 0 0 1 0 1.334h-.62a4.67 4.67 0 0 0 3.953 3.952V12a.667.667 0 0 1 1.333 0v.62a4.67 4.67 0 0 0 3.953-3.953H12a.667.667 0 0 1 0-1.334h.62a4.67 4.67 0 0 0-3.953-3.952V4a.667.667 0 1 1-1.333 0zM8 6.667a1.333 1.333 0 1 0 0 2.666 1.333 1.333 0 0 0 0-2.666M5.334 8a2.667 2.667 0 1 1 5.333 0 2.667 2.667 0 0 1-5.333 0",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "9aea938b-74c8-429a-b4cf-6e7b5595178aa"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
};
export default SvgTarget03;